import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './theme/globals.css'
import { App } from './App.js'
import { resetIfRequested } from './state/useStep.js'

resetIfRequested()

const root = document.getElementById('root')
if (!root) throw new Error('root element missing')
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
